module.exports = __webpack_public_path__ + "static/media/logo.4ef69ab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/tui/logo.png
// module id = 60
// module chunks = 0